module.exports = __webpack_public_path__ + "img/back-print.86f29ac8.svg";